import { AxiosError } from 'axios';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { App } from 'antd';

import { axiosClient } from '@/lib/axios';
import { queryClient } from '@/lib/react-query';

type Payload = {
  companyID: number;
  meetingID: number;
};

export const deleteMeeting = async ({ companyID, meetingID }: Payload): Promise<{ data: { message: string } }> => {
  const { data } = await axiosClient.delete<{ data: { message: string } }>(
    `/companies/${companyID}/meetings/${meetingID}`,
  );

  return data;
};
type UseDeleteMeetingOptions = {
  config?: Partial<UseMutationOptions<{ data: { message: string } }, AxiosError<{ message: string }>, Payload>>;
  postSuccess?: () => void;
};

export const useDeleteMeeting = ({ config, postSuccess }: UseDeleteMeetingOptions) => {
  const { notification: toaster } = App.useApp();
  return useMutation({
    onError: (error) => {
      toaster.error({
        message: 'Something Went Wrong',
        description: error.message,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['meetings'],
      });
      toaster.success({
        message: 'Deleted Successfully',
        description: 'Meeting Deleted Successfully',
      });
      postSuccess?.();
    },
    ...config,
    mutationFn: deleteMeeting,
  });
};
